<template>
  <Container v-if="!pending && data" class="bg-surface-default-low px-16 pt-24">
    <RevForm :initial-values name="gift-cards-selection">
      <template #default="{ values }">
        <div class="block gap-64 md:flex">
          <div
            class="sticky top-[168px] hidden max-w-[50%] self-start md:block"
          >
            <DesignPickers
              v-model="values.designId"
              :design-pickers="data.designPickers"
            />
          </div>

          <div>
            <div class="mb-32 space-y-32">
              <div class="space-y-8">
                <h2 class="text-static-default-hi heading-1">
                  {{ i18n(translations.title) }}
                </h2>
                <div class="text-static-default-hi body-2">
                  {{ i18n(translations.subtitle) }}
                </div>
              </div>

              <DesignPickers
                v-model="values.designId"
                class="md:hidden"
                :design-pickers="data.designPickers"
              />

              <ReassuranceItems />

              <PricePickers
                v-model="values.price"
                :max-price="data.customAmount.maximum"
                :min-price="data.customAmount.minimum"
              />

              <SelectedDesign
                class="md:hidden"
                :design-pickers="data.designPickers"
                :model-value="values.designId"
              />

              <div class="pt-32">
                <Proposal :price="values.price" />

                <PaymentIcons
                  class="my-24"
                  :methods="[PaymentMethodCode.CARD]"
                />

                <FormattedMessage
                  class="text-static-default-low caption"
                  :definition="translations.termsAndConditions"
                >
                  <template #termsAndConditionsLink>
                    <RevLink :to="i18n(translations.termsAndConditionsLink)">
                      {{ i18n(translations.termsAndConditionsLinkLabel) }}
                    </RevLink>
                  </template>
                </FormattedMessage>
              </div>

              <ReassuranceItems />
            </div>
          </div>
        </div>
      </template>
    </RevForm>

    <FaqDrawer />
  </Container>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { PaymentMethodCode } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import { PaymentIcons } from '@backmarket/nuxt-layer-payment/methods'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevForm } from '@ds/components/Form'
import { RevLink } from '@ds/components/Link'

import Container from '~/scopes/product/components/Container/Container.vue'

import translations from './GiftCards.translations'
import DesignPickers from './components/DesignPickers/DesignPickers.vue'
import FaqDrawer from './components/FaqDrawer/FaqDrawer.vue'
import PricePickers from './components/PricePickers/PricePickers.vue'
import Proposal from './components/Proposal/Proposal.vue'
import ReassuranceItems from './components/ReassuranceItems/ReassuranceItems.vue'
import SelectedDesign from './components/SelectedDesign/SelectedDesign.vue'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const { data, pending } = await useAsyncData(() =>
  $httpFetch('/api/gift-cards/v1/product-page/giftcard', {
    method: 'GET',
  }),
)

const {
  market: { defaultCurrency },
} = useMarketplace()

const initialValues = computed(() => {
  return {
    price: {
      amount: '20',
      currency: defaultCurrency,
    },
    designId: '1',
  }
})
</script>
